<div *ngIf="ticket" class="d-flex justify-content-center  min-height-100">
    <div class="row col-12 d-flex justify-content-center ">


        <div *ngIf="loading" class=" row col-12 d-flex justify-content-center mt-5">
            <app-spinner-loading></app-spinner-loading>
        </div>

        <div class="col-12 col-md-6 row  d-flex justify-content-center mt-5">
            <qrcode class="col-12 col-md-6" [elementType]="'img'" [qrdata]=" ticket.id" [errorCorrectionLevel]="'M'">
            </qrcode>


            <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
                {{ticket.id}}
            </p>
            <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
                {{ticket.created_at | date : 'dd/MM/yyyy, h:mm a'}}
            </p>

            <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
                {{ticket.email}}
            </p>
            <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
                {{ticket.name}}
            </p>
            <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
                <b>valido en : {{ticket.nameMenu}}</b>
            </p>

            <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">

                Detalle de compra : </p>
            <div *ngFor="let menu of ticket.items" class="col-12 col-md-12 mt-2 mb-2 ">
                <div class="card">
                    <div class="row card-body d-flex justify-content-center align-items-center">


                        <div class="col-12 col-md-6 row d-flex justify-content-center">
                            <div class=" col-12 mt-2 mb-2 d-flex justify-content-center">
                                <h5 class="card-title no-margin">Nombre : {{menu.title}}</h5>
                            </div>


                        </div>

                        <div class="col-12 col-md-6 row d-flex justify-content-center">
                            <div class=" col-4 mt-2 mb-2  d-flex justify-content-center">
                                <h5 class="card-title no-margin">Cantidad : {{menu.quantity}}</h5>
                            </div>
                            <div class=" col-4 mt-2 mb-2 d-flex justify-content-center">
                                <h5 class="card-title no-margin">Precio : {{menu.unit_price}}</h5>
                            </div>

                            <div class=" col-4 mt-2 mb-2  d-flex justify-content-center">
                                <h5 class="card-title no-margin">Total : {{menu.unit_price*menu.quantity}}</h5>
                            </div>
                        </div>



                    </div>

                </div>
            </div>
        </div>
    </div>
</div>



<div *ngIf="ticket" class="d-flex justify-content-center">
    <div class="footer col-12 row d-flex justify-content-center">
        <div class="col-12 col-md-6 row d-flex justify-content-center">
            <!-- <div class=" col-12 mb-3 d-flex justify-content-center">
                <button color="basic" class="col-12" mat-raised-button (click)="backToTickets(ticket.status)">Volver
                </button>
            </div> -->


        </div>
    </div>
</div>